import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import {
    HasProduct,
    HasProductContext,
    withProduct,
    withProductContext,
} from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import ReCaptcha from "@insite/content-library/Components/ReCaptcha";
import Button, { ButtonPresentationProps, ButtonWrapper } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconWrapper } from "@insite/mobius/Icon";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Select from "@insite/mobius/Select";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import Typography from "@insite/mobius/Typography";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import toggleLoginDrawer from "@NA/Handlers/ADILoginDrawerHandler";
import productDetailsReportIncorrect from "@NA/Handlers/ADIProductDetailsReportIncorrectHandler";
import { ProductDetailsPageContext } from "@NA/Overrides/Pages/ProductDetailsPage";
import ADIColors from "@NA/Utils/ADIColors";
import * as React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    text?: string;
    extendedStyles?: ADIProductShareLinkStyles;
}

type Props = OwnProps &
    HasProductContext &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasProduct;

const mapStateToProps = (state: ApplicationState) => ({
    session: state.context.session,
    currentPageUrl: getLocation(state),
});

const mapDispatchToProps = {
    productDetailsReportIncorrect,
    toggleLoginDrawer,
};

export interface ADIProductShareLinkStyles {
    link?: LinkPresentationProps;
    modal?: ModalPresentationProps;
    container?: GridContainerProps;
    recipientNameGridItem?: GridItemProps;
    recipientNameTextField?: TextFieldProps;
    recipientEmailGridItem?: GridItemProps;
    recipientEmailTextField?: TextFieldProps;
    yourNameGridItem?: GridItemProps;
    yourNameTextField?: TextFieldProps;
    yourEmailGridItem?: GridItemProps;
    yourEmailTextField?: TextFieldProps;
    yourMessageGridItem?: GridItemProps;
    yourMessageTextArea?: TextAreaProps;
    reCaptchaGridItem?: GridItemProps;
    buttonsWrapper?: InjectableCss;
    cancelButton?: ButtonPresentationProps;
    shareButton?: ButtonPresentationProps;
    reportincorrect?: InjectableCss;
}

export const adiProductShareLinkStyles: ADIProductShareLinkStyles = {
    reportincorrect: {
        css: css`
           font-size:14px;
           font-family:'Nunito Sans';
           color:#006AE3;
           ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css` text-decoration: underline; `,
                    css` text-decoration: underline; `,
                    css` text-decoration: underline; `,
                    null,
                    null,
                ])}
        `,
    },
    link: {
        typographyProps: {
            css: css`
                margin-bottom: 10px;
                > ${IconWrapper} {
                    svg {
                        width: 18px;
                        height: 22px;
                    }
                }
            `,
        },
    },
    modal: {
        size: 600,
        cssOverrides: {
            modalContainer: css`
                margin-top: 0;

                display: flex;

                align-items: center;

                justify-content: center;
                height: 100%;
                border-radius: 7px;
                padding: 28px 36px 31px 28px;

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            top: 77px;
                            padding-top: 18px !important;
                        `,
                        css`
                            top: 77px;
                            padding-top: 18px !important;
                        `,
                        css`
                            top: 98px;
                        `,
                        css`
                            top: 98px;
                        `,
                        css`
                            //top: 3%;
                        `,
                    ])}
                > div[class^="ContentBody"] {
                    height: auto;
                    max-height: calc(100% - 40px);
                    
                    margin: 45px;
                    max-width: 548px;
                    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14),
                        0px 1px 18px 0px rgba(0, 0, 0, 0.12);
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                padding: 24px 10px 28px 10px !important;
                                margin: 10px;
                            `,
                            css`
                                padding: 24px 10px 28px 10px !important;
                                margin: 10px;
                            `,
                            css``,
                            css``,
                            css``,
                        ])}
                }
            `,

            modalBody: css`
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            border-radius: 0px;
                        `,
                        css`
                            border-radius: 0px;
                        `,
                        css`
                            border-radius: 0px;
                        `,
                        css`
                            border-radius: 10px;
                        `,
                        css`
                            border-radius: 10px;
                        `,
                    ])}
            `,
            modalTitle: css`
                padding: 10px 30px;
                padding-top: 15px;
                border-bottom: 0px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                        padding: 10px 0px 0px 0px;
                        `,
                        css`
                        padding: 10px 0px 0px 0px;
                        `,
                        css`
                           
                        `,
                        css`
                            
                        `,
                        css`
                           
                        `,
                    ])}
                > ${ButtonWrapper} {
                    position: relative;
                    left: 15px;
                    top: -10px;
                    :hover {
                        background: none;
                        border-color: transparent;
                    }
                    > ${IconWrapper} {
                        height: 45px;
                        width: 45px;
                        color: ${getColor("primary")};

                        > svg {
                            height: 35px;
                            width: 35px;
                            ${({ theme }: { theme: BaseTheme }) =>
                                breakpointMediaQueries(theme, [
                                    css`
                                    position:relative;
                                    top:-41px;
                                    `,
                                    css`
                                    position:relative;
                                    top:-41px;
                                    `,
                                    css`
                                       
                                    `,
                                    css`
                                        
                                    `,
                                    css`
                                       
                                    `,
                                ])}
                        }
                    }
                }
                > ${TypographyStyle} {
                    font-family: 'Nunito Sans', sans-serif;
                    font-weight: bold;
                    line-height: normal;
                    color: #002856;
                    margin-bottom: 10px;
                    min-height: 38px;
                    font-size:28px;
                   


    ${({ theme }: { theme: BaseTheme }) =>
        breakpointMediaQueries(theme, [
            css`
            margin-bottom: 0px;
            `,
            css`
            margin-bottom: 0px; 
            `,
            css`
           
            `,
            css`
           
         
            `,
            css`
               
            `,
        ])}
                }
            `,
            modalContent: css`
                padding: 20px 30px;
                padding-top: 0px;
                padding-bottom: 30px;
                margin-top: -10px;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                        padding: 20px 0px 20px 0px;
                        `,
                        css`
                        padding: 20px 0px 20px 0px;
                        `,
                        css`
                           
                        `,
                        css`
                            
                        `,
                        css`
                           
                        `,
                    ])}
            `,
        },
    },
    container: {
        gap: 10,
        css: css`
            padding-top: 10px;
           
        `,
    },
    recipientNameGridItem: {
        width: 6,
        css: css`
            padding-right: 10px;
        `,
    },
    recipientEmailGridItem: {
        width: 12,
        css: css`
      
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
               margin-top:10px;
                `,
                css`
                margin-top:10px;
                `,
                css`
                   
                `,
                css`
                    
                `,
                css`
                   
                `,
            ])}
            padding-left: 10px;
            select[aria-invalid="true"] {
                border-color: ${ADIColors.errorMsgRed}!important;
                background-color: ${ADIColors.errorFieldBgRed}!important;
                border: 1px solid ${ADIColors.errorMsgRed}!important;
            }
        `,
    },
    yourNameGridItem: {
        width: 6,
        css: css`
            padding-right: 10px;
        `,
    },
    yourEmailGridItem: {
        width: 12,
        css: css`
            padding-left: 10px;
            input[aria-invalid="true"] {
                border-color: ${ADIColors.errorMsgRed}!important;
                background-color: ${ADIColors.errorFieldBgRed}!important;
                border: 1px solid ${ADIColors.errorMsgRed}!important;
            }
        `,
    },
    yourMessageGridItem: {
        width: 12,
        css: css`
            textarea[aria-invalid="true"] {
                border-color: ${ADIColors.errorMsgRed}!important;
                background-color: ${ADIColors.errorFieldBgRed}!important;
                border: 1px solid ${ADIColors.errorMsgRed}!important;
            }
        `,
    },
    yourMessageTextArea: {
        cssOverrides: {
            inputSelect: css`
                resize: none;
            `,
        },
    },
    reCaptchaGridItem: {
        width: 12,
    },
    buttonsWrapper: {
        css: css`
            margin-top: 25px;
            text-align: right;
        `,
    },
    cancelButton: {
        variant: "secondary",
    },
    shareButton: {
        css: css`
            margin-left: 10px;
        `,
    },
};

const ADIProductDetailsReportIncorrect: React.FC<Props> = ({
    product,
    session,
    productDetailsReportIncorrect,
    extendedStyles,
    toggleLoginDrawer,
    currentPageUrl,
}) => {
    const [styles] = React.useState(() => mergeToNew(adiProductShareLinkStyles, extendedStyles));
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const [newModalIsOpen, setnewModalIsOpen] = React.useState(false);
    const [feedbackfor, setFeedbackfor] = React.useState("");
    const [feedbackforError, setFeedbackforError] = React.useState("");
    const [feedbackMessage, setFeedbackMessage] = React.useState("");
    const [feedbackMessageError, setFeedbackMessageError] = React.useState("");
    const [feedbackEmail, setFeedbackEmail] = React.useState("");
    const [feedbackEmailError, setFeedbackEmailError] = React.useState("");
    const [showSentReportModal, setshowSentReportModal] = React.useState(false);
    const [inProgress, setInProgress] = React.useState(false);

    const modalCloseHandler = () => {
        setModalIsOpen(false);
        setnewModalIsOpen(false);
        setTimeout(() => {
            setshowSentReportModal(false);
        }, 1000);
    };

    const shareLinkClickHandler = () => {
        
        resetFields();
        setModalIsOpen(true);
    };

    const requiredFieldMessage = translate("This is a required field");
    const emailFieldMessage = translate("Enter a valid email address");
    const checkForErrors = () => {
        const regexp = new RegExp(/^[A-Za-z0-9]+([._+-][a-zA-A0-9]+)*@[a-zA-A0-9-]+\.[a-zA-A]{2,}$/);
        const regTextexp = new RegExp(/^[A-Za-z0-9\s.,!?'"()&:;/-]*$/);

        const localRecipientEmailError = !feedbackEmail
            ? requiredFieldMessage
            : regexp.test(feedbackEmail)
            ? ""
            : emailFieldMessage;
        setFeedbackEmailError(localRecipientEmailError);

        const localfeedbackMessageError = !feedbackMessage
            ? requiredFieldMessage
            : regTextexp.test(feedbackMessage)
            ? ""
            : translate("Special characters are not allowed");
        setFeedbackMessageError(localfeedbackMessageError);

        const localYourEmailError = !feedbackfor
            ? requiredFieldMessage
            : regTextexp.test(feedbackfor)
            ? ""
            : emailFieldMessage;
        setFeedbackforError(localYourEmailError);

        return !!(localRecipientEmailError || localYourEmailError || localfeedbackMessageError);
    };

    const resetFields = () => {
        setFeedbackfor("");
        setFeedbackforError("");
        setFeedbackMessage("");
        setFeedbackMessageError("");
        setFeedbackEmail("");
        setFeedbackEmailError("");
        setInProgress(false);   //Comment added by Zahir
    };

    const handleSelectedWishListIdChange = (event: React.FormEvent<HTMLSelectElement>) => {
        setFeedbackfor(event.currentTarget.value);
        setFeedbackforError(!event.currentTarget.value ? requiredFieldMessage : "");
    };

    const yourMessageChangeHandler = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setFeedbackMessage(event.target.value);
        setFeedbackMessageError(!event.target.value ? requiredFieldMessage : "");
    };

    const recipientEmailChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFeedbackEmail(event.target.value);
        setFeedbackEmailError(!event.target.value ? requiredFieldMessage : "");
    };

    const shareButtonClickHandler = async () => {
      
        if (checkForErrors()) {
            return;
        }
        setInProgress(true);
        productDetailsReportIncorrect({
            feedbackEmail,
            feedbackMessage,
            feedbackfor,
            productUrl: currentPageUrl.pathname,
            sku: "",
            onSuccess: () => {
                setshowSentReportModal(true);
            },
        });
    };

    const recaptchaRef: React.RefObject<ReCAPTCHA> = React.createRef();

    return (
        <>
            <Link {...styles.link} onClick={shareLinkClickHandler} data-test-selector="productShareLink">
                <Typography {...styles.reportincorrect}   >{translate("Report Incorrect Product Information  ")}</Typography>
            </Link>

            <Modal
                {...styles.modal}
                headline={translate("Report Product Information")}
                isOpen={modalIsOpen}
                handleClose={modalCloseHandler}
            >
                {showSentReportModal ? (
                    <>
                        <Typography>
                            {translate(
                                `Thank you for submitting an incorrect product report for ${product?.detail?.name}`,
                            )}
                        </Typography>
                    </>
                ) : (
                    <>
                        <Typography>*{translate("Required Fields")}</Typography>
                        <GridContainer {...styles.container} data-test-selector="productShareModal">
                            <GridItem {...styles.recipientEmailGridItem}>
                                <Select
                                    label="Feedback for *"
                                    placeholder="Select Department"
                                    hint=""
                                    onChange={handleSelectedWishListIdChange}
                                    value={feedbackfor}
                                    error={feedbackforError}
                                >
                                    <option value="" selected>
                                        Select Department
                                    </option>
                                    <option value="Image">Image</option>
                                    <option value="Title">Title</option>
                                    <option value="Description">Description</option>
                                    <option value="Specifications">Specifications</option>
                                    <option value="Documents">Documents</option>
                                </Select>
                            </GridItem>
                            <GridItem {...styles.yourMessageGridItem}>
                                <TextArea
                                    label={translate("Your Feedback *")}
                                    value={feedbackMessage}
                                    error={feedbackMessageError}
                                    onChange={yourMessageChangeHandler}
                                    data-test-selector="productShareYourMessage"
                                    {...styles.yourMessageTextArea}
                                />
                            </GridItem>
                            <GridItem {...styles.yourEmailGridItem}>
                                <TextField
                                    label={translate("Your Email *")}
                                    value={feedbackEmail} 
                                    error={feedbackEmailError}
                                    onChange={recipientEmailChangeHandler}
                                    data-test-selector="productShareRecipientEmail"
                                    {...styles.recipientEmailTextField}
                                />
                            </GridItem>
                            <GridItem {...styles.reCaptchaGridItem}>
                                <ReCaptcha recaptchaRef={recaptchaRef} location="ShareProduct" />
                            </GridItem>
                        </GridContainer>
                        <StyledWrapper {...styles.buttonsWrapper}>
                            <Button
                                {...styles.cancelButton}
                                onClick={modalCloseHandler}
                                data-test-selector="productShareCancel"
                            >
                                {translate("Cancel")}
                            </Button>
                            <Button
                                {...styles.shareButton}
                                onClick={shareButtonClickHandler}
                                data-test-selector="productShareSubmit"
                                disabled={inProgress}
                            >
                                {translate("Submit")}
                            </Button>
                        </StyledWrapper>
                    </>
                )}
            </Modal>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withProduct(withProductContext(ADIProductDetailsReportIncorrect))),
    definition: {
        displayName: "ADI PDP Report Incorrect",
        group: "Product Details",
        allowedContexts: [ProductDetailsPageContext],
    },
};

export default widgetModule;
